import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { mapGoogleWorkspaceAuthError, signInWithGoogleWorkspace } from '../../firebase/googleAuth';
import {
  canOpenSkillsyncShare,
  isSkillsyncShareExpired,
  isSkillsyncShareHost,
  SKILLSYNC_SHARE_EXPIRES_LABEL,
} from './skillsync-share-expiry';
import './SkillSyncReviewHub.css';

/**
 * En el canal público, las cotizaciones no se montan hasta que entra
 * christian@plexarian.com o andreag@plexarian.com. En local el catálogo sigue abierto.
 */
export default function SkillsyncShareGate({ children }) {
  const locked = isSkillsyncShareHost();
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(!locked);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!locked) return undefined;
    return onAuthStateChanged(auth, (next) => {
      setUser(next || null);
      setReady(true);
    });
  }, [locked]);

  if (!locked) return children;

  if (isSkillsyncShareExpired()) {
    return (
      <div className="ssrh-expired">
        <img src="/assets/logo-plexarian.svg" alt="Plexarian" />
        <h1>Este enlace ya cerró</h1>
        <p>La revisión de cotizaciones estuvo disponible hasta el {SKILLSYNC_SHARE_EXPIRES_LABEL}.</p>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="ssrh-expired">
        <img src="/assets/logo-plexarian.svg" alt="Plexarian" />
        <p>Comprobando acceso…</p>
      </div>
    );
  }

  const email = String(user?.email || '').toLowerCase().trim();
  if (user && canOpenSkillsyncShare(email)) return children;

  const enter = async () => {
    setBusy(true);
    setError('');
    try {
      if (user) await signOut(auth);
      await signInWithGoogleWorkspace();
    } catch (err) {
      if (err?.code === 'auth/popup-closed-by-user' || err?.code === 'auth/cancelled-popup-request') {
        setError('');
      } else {
        setError(mapGoogleWorkspaceAuthError(err?.code, err?.message));
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ssrh-expired">
      <img src="/assets/logo-plexarian.svg" alt="Plexarian" />
      <h1>Revisión privada</h1>
      {user ? (
        <p>
          {email} no tiene acceso a estas cotizaciones. Entra con la cuenta de Andrea o la de Christian.
        </p>
      ) : (
        <p>
          Entra con tu cuenta de Google de Plexarian. Solo Andrea y Christian pueden ver estas cotizaciones.
          El enlace cierra el {SKILLSYNC_SHARE_EXPIRES_LABEL}.
        </p>
      )}
      {error ? <p className="ssrh-gate-error">{error}</p> : null}
      <button type="button" className="ssrh-open" onClick={enter} disabled={busy}>
        {busy ? 'Abriendo Google…' : (user ? 'Usar otra cuenta' : 'Entrar con Google')}
      </button>
    </div>
  );
}
